module.exports = __webpack_public_path__ + "media/images/icons/testimonial-fallback-dfe35469714db3a753cdf7888eeb2dc0.svg";